import { CountryCode } from '@carsys/enums/country-code'

export const euCountries: CountryCode[] = [
  CountryCode.AT,
  CountryCode.BE,
  CountryCode.BG,
  CountryCode.HR,
  CountryCode.CY,
  CountryCode.CZ,
  CountryCode.DK,
  CountryCode.EE,
  CountryCode.FI,
  CountryCode.FR,
  CountryCode.DE,
  CountryCode.GR,
  CountryCode.HU,
  CountryCode.IE,
  CountryCode.IT,
  CountryCode.LV,
  CountryCode.LT,
  CountryCode.LU,
  CountryCode.MT,
  CountryCode.NL,
  CountryCode.PL,
  CountryCode.PT,
  CountryCode.RO,
  CountryCode.SI,
  CountryCode.ES,
  CountryCode.SE
]

export const countryCodeMapping: { [key in keyof typeof CountryCode]?: string } = {
  [CountryCode.AT]: 'A',
  [CountryCode.BE]: 'B',
  [CountryCode.EE]: 'EST',
  [CountryCode.FI]: 'FIN',
  [CountryCode.FR]: 'F',
  [CountryCode.DE]: 'D',
  [CountryCode.HU]: 'H',
  [CountryCode.IE]: 'IRL',
  [CountryCode.IT]: 'I',
  [CountryCode.LU]: 'L',
  [CountryCode.MT]: 'M',
  [CountryCode.PT]: 'P',
  [CountryCode.SI]: 'SLO',
  [CountryCode.ES]: 'E',
  [CountryCode.NO]: 'N',
  [CountryCode.SE]: 'S'
}
